import { render, staticRenderFns } from "./offic.vue?vue&type=template&id=70bcf431&scoped=true&"
import script from "./offic.vue?vue&type=script&lang=js&"
export * from "./offic.vue?vue&type=script&lang=js&"
import style0 from "./offic.vue?vue&type=style&index=0&id=70bcf431&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bcf431",
  null
  
)

export default component.exports